<template>
    <div class="ve-list-page ord-sent-page">
        <div style="display:flex;line-height:25px ;  "> 
            <div  class="oneMenu" @click="itemClick('one')">
                <div style="margin-left:0px" :class="{active: actitem==='one'}" >
                    <i class="iconfont icon-huizong" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1362', '发货通知-汇总') }}</div>
            </div>
            <div  class="oneMenu" @click="itemClick('two')">
                <div style="margin-left:40px" :class="{active: actitem==='two'}" >
                    <i class="iconfont icon-a-baobiaoguanlibaobiao" style="margin-left:4px;margin-right:5px"></i>{{ $LANG('1361', '发货通知-明细') }}</div>
            </div>
        </div>
        <div v-if="actitem=='two'" class="ve-list-page__body">
            <out-two></out-two>
        </div>
        <div v-show="actitem=='one'" style=" display:flex;   background:#fff;line-height:30px;height:40px ;border-bottom:2px solid #389;">
            <div style="min-width:1100px;display:flex;padding-top:3px">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" ><span style="font-size:13px;margin-right:15px;font-weight:600">{{ $LANG('0138', '新增') }} </span></el-link>
                </div> 
                <!-- <el-checkbox border size="small"  @change="selChg"  v-model="v_sel" true-label="Y"  false-label="N"><span style="font-size:12px;color:#389;margin-right:5px">全选</span></el-checkbox>   -->
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in stkCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <!-- <el-button type="danger"   icon="iconfont icon-daochu" @click="nextGen" size="mini" style="margin-left:15px;height:30px;margin-top:1px">下推应收单</el-button> -->
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>  
        <div v-show="actitem=='one'" class="ve-list-page__table">
        <ve-table :columns="vueCol"
            :table-data="rtnData"
            :columnHiddenOption="columnHiddenOption"
            :border-around="true"
            :border-x="true"
            :border-y="true"
            :fixed-header="true"
            row-key-field-name="IDSEQ"
            :row-style-option="rowStyleOption"
            :cell-style-option="cellStyleOption"
            :max-height="subHeight"
            :virtual-scroll-option="virtualScrollOption"
            :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
            :scroll-width="0"
            :column-width-resize-option="columnWidthResizeOption"
            :cellSelectionOption="{enable: false}"
            v-loading="v_loading"
            id="ord_sent_load"
            ref="refreq">
        </ve-table>
        </div>
        <!-- 分页查询 -->
        <div v-show="actitem=='one'" class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" v-dialogDrag  :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="poRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in stkCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="poRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="poRow[item.key]" style="width:100%" ></el-input-number>   
 
                            <el-select size="medium"  v-else-if="item.key==='STAFF'" v-model="poRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in empArr" :key="index" :label="item.EMPNM" :value="item.EMPNM"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="poRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
 
                <div class="one-div"><span class="oneRow"  > {{ $LANG('0639', '发货明细') }}</span>
                    <el-button :disabled="saveFlag" @click="refSale" type="primary" plain size="mini" style="height:25px;margin-top:2px;margin-left:20px;border:1px solid green">
                        <i class="iconfont  icon-icon-choose" style=" font-size:12px;margin-right:3px"></i>{{ $LANG('1338', '选择销售订单') }}
                    </el-button> 
                </div>
                <el-table  :data="dtlData" 
                    border                            
                    size="small"
                    class="custom-table-border"
                    :cell-style="{padding:'2px','font-size':'12px',color:'black'}"
                    :height="350" 
                    :row-key="getDtlKey"
                    v-loading="t_loading"              
                    :element-loading-text="$LANG('1959', '加载中')"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(255, 251, 255, 0.8)"
                    style="margin-top:-8px"
                    ref="refdtl"
                    show-summary
                    :summary-method="getSummary"
                    highlight-current-row > 
                    <el-table-column :label="$LANG('0310', '序号')" type="index" width="55"></el-table-column>
                    <el-table-column v-for="(item,index ) in dtlCol.filter(item=>item.thide==='N')" :key="index"
                        :prop="item.key"
                        :fixed="item.key==='RN'"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        sortable
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>  
                        <template slot-scope="scope">
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >   
                                <el-input type="number" size="mini" @input="qtyPrc(scope.row,scope.$index)" :disabled="item.disabled==='Y'" v-if="item.edcss==='number'"  v-model="scope.row[item.key]"  @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" style="width:100%"></el-input>                   
                                <el-input  v-else-if="item.disabled=='N' " size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>                                 
                                <span v-else  v-text="scope.row[item.key]" style="width:100%"> </span> 
                            </span>
                        </template> 
                    </el-table-column>    
                   
                    <el-table-column
                        fixed="right"
                        :label="$LANG('0330', '操作')"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
 
                            <el-button size="mini" :disabled="saveFlag"  type="text" icon="iconfont icon-shanchu1" @click="dtlDel(scope.row,scope.$index )">{{ $LANG('0131', '删除') }}</el-button>
                        </template>
                    </el-table-column>  
                </el-table>
                <div class="one-toolbar">
                    <span class="spanRow"> {{ $LANG('0516', '上传附件') }}</span>
                </div>
                <div style="display:flex" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"       
                        :max-size="20480"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :with-credentials="true"
                        :on-progress="handleProgress"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">{{ $LANG('1842', '将文件拖动此处或点击上传') }}</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex;margin-left:30px;"  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH"></el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link  :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> {{ $LANG('0131', '删除') }}</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> {{ $LANG('0141', '预览') }}</el-link>
                                <el-link v-else :underline="false" style="margin-right:3px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>{{ $LANG('0129', '下载') }}</el-link>
                            </div>
                        </span>
                    </div> 
                </div>
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">            
                    <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> {{ $LANG('1497', '提示：订单审核后不能再编辑 , 如需编辑请弃审') }}</i>
                    <span style="margin-right:20px">
                        <i v-if="poRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="poRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="poRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  {{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag"  @click="saveRec" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > {{ $LANG('0130', '保存') }} </el-button>
                </span>
            </div>
        </el-dialog>
        <!-- 上传进度 -->
        <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">{{ $LANG('2052', '正在上传中...') }}</span>
            </div>
            <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
        </el-dialog>
         <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol"  v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <!-- 销售订单 -->
        <el-dialog  :visible.sync="saleWin" v-if="saleWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('1338', '选择销售订单') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <pub-ord v-bind:v_cond="v_cond" v-bind:tabCol ="tableCol" v-bind:v_table="v_table"  @child-sure="saleOk" @child-exit="saleWin=false"></pub-ord>
            </div>
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <VeColumnConfigDialog
            :visible="fieldSettingDialog.visible"
            :rows="fieldSettingDialog.rows"
            :loading="fieldSettingDialog.loading"
            :error="fieldSettingDialog.error"
            :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
            :drag-group-field="fieldSettingDialog.dragGroupField"
            :language="$store.state.lang"
            @update:visible="fieldSettingDialog.visible = $event"
            @change="updateFieldSettingsDraft"
            @confirm="saveFieldSettingsDialog"
            @reset="resetFieldSettingsDialog"
            @close="closeFieldSettingsDialog"
        />
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'   
import outTwo from './ord_sent_two.vue'
import pubOrd from '../datamgt/pubmulti.vue'  
import pubWin from '../datamgt/pubmulti.vue' 
import FileSaver from 'file-saver' 
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'ord_sent',
    mixins: [createVeTableFieldSettingMixin({
        settingFormId: '470845',
        fieldIdseq: '470845',
        fieldLstseq: '1',
        mainColumnKey: 'stkCol',
        tableColumnKey: 'vueCol',
        initColumnKey: 'initCol',
        tableRef: 'refreq',
        generatedFixedColumnKeys: ['rownum', 'oper'],
    })],
    data () {
        return {
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            btnWin:false,
            uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
            saleWin:false,
        
            dtlRow:{},
            ordWin:false,
            v_sel:'N',
 
            v_row:{},
            promptWin:false,
            dtlFlag:'create',
       
            t_loading:false,
            addFlag:'create',
            actitem:'one',
            rowDtl:{},
  
 
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            v_commit:true,
            selparam:'IDNO',
            txtparam:'',
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            poRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            rtnData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            v_loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            empArr:[],
            pageList: [{
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                } ],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            stkCol:[],
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            notNull:[],
            v_idseq:this.$cookies.get('idseq'),
            dtlIndex:'',
            ordCol:[],
            comboArr:[],
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            repUrl:'',
            repWin:false,
            uploadData:{}, //上传数据
            videoFlag:false,
            videoUploadPercent:0,
            imgData:[],
            fileName:'',
            delImg:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: { defaultHiddenColumnKeys: [] },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
        }
    },
    components: {
        pubOrd,
        pubWin,
        outTwo,
        repWin,
        VeColumnConfigDialog,
        // JSX query headers are resolved at runtime.
        // eslint-disable-next-line vue/no-unused-components
        VeTableQueryHeader,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 192) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 245) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth- 140) + 'px';
        },
    },
    mounted () {
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        //客户
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','V_HR_EMP_STFG','').then(res=>{
            this.empArr =res.result
        });
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','470845','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','470845','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','470845','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.stfgChange() //  
 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        downFile(filePath){
            const arr_name=filePath.split("/")
            const file_name=arr_name[arr_name.length-1] //获取文件名
            FileSaver.saveAs(filePath,file_name) 
        },
        //预览PDF
        pdfViewer(path){
            let routeUrl = this.$router.resolve({
                path: '/fullPreview',
                query: {fileUrl: path},
            });
            window.open(routeUrl.href, '_blank');
        },
        //图片删除，操作数组
        imgDel(item,index){
            if(item['IDSEQ'] && item['LSTSEQ']){
                
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'refidseq',p_value:item['IDSEQ'],p_key2:'reflstseq',p_value2:item['LSTSEQ'],p_table:'V_MAT_IMG'},
                }).then(res=>{  
                    //console.log(item['IDSEQ'],item['LSTSEQ'],res.result.length)
                    if(res.result.length>0 && res.result){
                        let v_idno =res.result[0]['MATIDNO']
                        this.promptWin =true
                        this.prompt =this.$LANG('1398', '此附件已被编码：')+v_idno+this.$LANG('0823', '引用，如需删除此图片请先删除引用的图片')
                    }else{
                        this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
                            confirmButtonText: this.$LANG('1638', '确定'),
                            cancelButtonText:this.$LANG('0132', '取消'),
                            customClass:'messageBox',
                            showClose:false,
                            closeOnClickModal:false,
                            closeOnPressEscape:false,
                            type:'info',
                        }).then(()=>{
                            this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                            this.imgData.splice(index, 1);    
                        }).catch(()=>{})
                    }
                })
            }else{
                this.$confirm(this.$LANG('1594', '你确定要删除此图片吗'),this.$LANG('1442', '提示'),{
                    confirmButtonText: this.$LANG('1638', '确定'),
                    cancelButtonText:this.$LANG('0132', '取消'),
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.delImg.push({IDSEQ:item['IDSEQ'],LSTSEQ:item['LSTSEQ'],FILEPATH:item['FILEPATH'],PATH:item['PATH']}) 
                    this.imgData.splice(index, 1);    
                }).catch(()=>{})
            }
        },
        //上传显示进度
        handleProgress(event,file,fileList){
            this.videoFlag = true
            this.videoUploadPercent = Math.floor(event.percent)
        },
        //文件格式验证错误时的钩子
        handleFormatError (file) {
            this.promptWin =true
            this.prompt=this.$LANG('1455', '文件格式错误,')+file.name + this.$LANG('1431', ' 是不正确, 请选择pdf或图片格式')
        },
        //文件超出指定文件大小限制的钩子
        handleMaxSize (file) {
            this.promptWin =true
            this.prompt=file.name + this.$LANG('1561', ' 文件太大, 不能超出')+'20M'
        },
        // 文件上传成功时的钩子
        successImgFile(res,file){
            this.videoUploadPercent=0 
            this.videoFlag = false
            if (res.code=='200'){
                this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
            }else if (res.code=='201'){ // 文件哈希值存在的情况下
                this.imgData.push({FILEPATH: res.filepath,FILENM:file.name,FILETY:'IMG',PATH:'',REFIDSEQ:res.idseq,REFLSTSEQ:res.lstseq})                   
            }else{
                this.promptWin =true
                this.prompt =res.result
            }               
        },
        //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
        beforeImgFile (res, file) {        
            this.fileName= getDate('year')+'-SENT'     
            this.uploadData = {
                code: this.fileName ,
                p_type:'IMG',
                p_path:'/web/web_images/material/',
                p_user:this.v_username
            }
            let promise = new Promise(resolve => {
            this.$nextTick(function() {
                    resolve(true);
                });
            });
            return promise; 

        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='ORDQTY'||column.property==='QTY' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(1)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        //销售订单选择
        saleOk(data_){
            if (data_.length>0){ //IDNO,MATNM,MATDESC,MODELNM,MATTYNM,PRC,TTLAMT,QTY ::TAXPRC,AMT
                for(let k=0;k<data_.length;k++){
                    let v_bool =true
                    this.dtlData.some(item=>{
                        if (item['REFIDSEQ']==data_[k].IDSEQ && item['REFLSTSEQ']==data_[k].LSTSEQ){
                            v_bool =false
                        }
                    })
                    if (v_bool){
                        let obj_={}
                        Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,IDSEQ:'',LSTSEQ:'', ORDQTY:data_[k]['QTY'],
                            ORDNO:data_[k].IDNO,REFIDSEQ:data_[k].IDSEQ,REFLSTSEQ:data_[k].LSTSEQ,UNITNM:data_[k]['UNITNM'],QTY:data_[k]['QTY'],
                            OKQTY:data_[k]['OKQTY'], CLNTNM:data_[k]['CLNTNM'],MATTYNM:data_[k]['MATTYNM'],PRC:data_[k].PRC,TAX:data_[k].RATENUM,
                            STKNM:data_[k].STKNM,STKNO:data_[k].STKNO} )
                        
                        this.dtlData.push(obj_)
                    }
                }   
            }
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
            this.saleWin=false
        },
        refSale(){
            this.v_table ='V_ORD_WAIT'
            this.tableCol =this.ordCol
            this.v_cond=''
            this.saleWin=true
        },
        rowShow(){  
            this.v_row ={}
            this.current =1
            this.stfgChange()
        } ,
        itemClick(val){
            this.actitem =val     
        },
        //销售订单选择
        btnSure(data_){
            if (data_.length>0){ //IDNO,MATNM,MATDESC,MODELNM,MATTYNM,PRC,TTLAMT,QTY ::TAXPRC,AMT
                for(let k=0;k<data_.length;k++){
                    let obj_={}
                    Object.assign(obj_,{MATNO:data_[k].MATNO,MATNM:data_[k].MATNM,MATDESC:data_[k].MATDESC,RTN_ORDNO:data_[k].CLTORDNO,LSTSEQ:'',RTN_CLNTNM:data_[k].ORDCLNTNM,STKNO:data_[k].STKNO,
                    UNITNM:data_[k].UNITNM, STKNM:data_[k].STKNM,MATTYNM:data_[k].MATTYNM,POQTY:data_[k].ACTQTY, REFIDNO:data_[k].IDNO,REFIDSEQ:data_[k].IDSEQ,
                    PRC:data_[k].PRC,TAX:data_[k].RATENUM, REFLSTSEQ:data_[k].LSTSEQ,TAXPRC:data_[k].PRC})
                    this.dtlData.push(obj_)
                }   
            }
            this.btnWin=false
        },
 
        qtyPrc(row,index){
            if(row['ACTQTY'] && row['TAXPRC']){
                row['AMT']=(Number(row['ACTQTY'])*Number(row['TAXPRC'])).toFixed(2) // *(100+Number(tax))/100
            }else{
                row['AMT']=0
            }
        },
 
        // 明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.t_loading=true
            getTabColOrData(this.v_url,'V_ORD_SENTDTL','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.t_loading =false
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refdtl.doLayout()  
                }) 
            })          
        },
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
        //查询附件数据
        qryImgData(idseq){
             this.imgData=[]
            getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {
                if (res){
                    this.imgData =res.result
                }
            })
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.poRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            //明细
            this.getDtlList(row.IDSEQ)
            this.qryImgData(row.IDSEQ)
            this.addWin=true   
            this.delImg=[]   
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.poRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                        this.prompt=item.FLDNM+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            if (this.stfgBool && this.v_commit) {         
                let v_flag=false  ,v_title=''  
                this.dtlData.forEach(item=>{
                    this.dtlCol.filter(item2=>item2.notnull=='Y').some(it=>{
                        if (!item[it['key']]){
                            v_flag =true
                            v_title=it['title']
                        }
                    })
                })
                if (v_flag ){
                    this.promptWin =true
                    this.prompt =this.$LANG('1267', '明细资料中的')+' "'+v_title +'" '+this.$LANG('2051', '不能为空')
                }else if (this.dtlData.length==0 ){
                    this.promptWin =true
                    this.prompt =this.$LANG('0109', '明细资料')+this.$LANG('2051', '不能为空')
                }else{
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.poRow,{CORPID:this.v_corpid })), p_table:'ORD_SENT',frmid:'470845'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'ORD_SENTDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                    this.v_commit=true
                                }else{
                                    this.stfgChange()
                                    this.v_commit=true
                                }
                            })
                            //明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'ORD_SENTdtl', p_action:'D' },
                                })
                            } 
                            //3、图片保存
                            for(var k=0;k<this.imgData.length;k++){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/tableBodySave',
                                    data: {p_json:JSON.stringify(Object.assign(this.imgData[k] )), p_table:'mat_img',p_idseq:idseq_},
                                })
                            }  
                            //图片删除处理
                            for(let k=0;k<this.delImg.length;k++){
                                let v_filepath=this.delImg[k]['FILEPATH'],v_path=this.delImg[k]['PATH']
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:this.delImg[k]['IDSEQ'],p_key2:'lstseq',p_value2:this.delImg[k]['LSTSEQ'],p_key5:'filepath',p_value5:this.delImg[k]['FILEPATH'],p_table:'mat_img'},
                                }).then(res=>{      
                                    if(res.code !=='200')  {  
                                        this.prompt=res.message
                                        this.promptWin=true
                                    }else{                          
                                        //删除群晖上的文件 ,如果 是重复文件上传时 v_path 是空的，这时是不要删除真正的文件
                                        if (v_filepath.indexOf('https://')>-1 && v_filepath && v_path){
                                            this.$axios({
                                                method: 'post',
                                                url: '/xuper_oss/ftpDelete',
                                                data: {p_path:'/volume1'+v_path},
                                            }).then(res=>{ 
                                                console.log(res.result)
                                            })
                                        }
                                    }        
                                })        
                            } 
                            this.addWin =false   
                            
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                            this.v_commit=true
                        }        
                    }) 
                }
            }
         
        },
        //新增
        addRec(){
            this.addWin=true
            this.poRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N',STAFF:this.v_usernm }
            this.dtlData=[]
            this.imgData=[]
            this.saveFlag=false
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            if (row.IDSEQ && row.LSTSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ
        },
 
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                    v_comm=this.$LANG('0134', '审核')
            }else if (val==='N'){
                    v_comm=this.$LANG('2005', '未审核')
            }else if (val==='X'){
                    v_comm=this.$LANG('0257', '作废')
            }
            if (val=='Y'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ORD_SENT',p_cond:v_cond },
                }).then(res=>{      
                    if(res.code =='200')  {   
                        if (val =='X'){
                            this.rtnData.splice(index,1)
                        }else{     
                            Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                        }
                    }else{
                        const errorMsg =res.result
                        const startIndex = errorMsg.indexOf("ORA-20001:") 
                        const endIndex = errorMsg.indexOf("请核查") +3
                        const extractedValue = errorMsg.substring(startIndex, endIndex).trim()
                        if (startIndex>0){
                            this.prompt =extractedValue
                        }else{
                            this.prompt =res.result
                        }
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        stfgChange(){
            const toolbarCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
                ? ` and ${this.selparam} is null `
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, {
                typeOverrides: { STFG: 'select', SEL: 'checkbox' },
                numberOperatorDefault: '>=',
            })
            this.current =1
            this.getTabList(toolbarCondition+headerCondition)
        }, 
        sortHeaderColumn(column){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            else {
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            this.stfgChange()
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.rtnData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.rtnData = this.allList          
            }else{
               
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.rtnData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //发货单 
        getTabList(cond){
            const requestId =++this.queryRequestId
            this.v_loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey)
                ? this.headerSortKey
                : (isVeTableMetadataField(this.initCol, this.selparam) ? this.selparam : 'IDNO')
            const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
            getTabColOrData(this.v_url,'V_ORD_SENT','','','CORPID',this.v_corpid,'','',`${cond} order by ${orderField} ${orderDirection}`).then((res) => {
                if (requestId !== this.queryRequestId) return
                this.allList =res.result || []
                this.initPage() 
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.v_loading =false
            })
        },
 
 
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','470845','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.stkCol = []
                    vm.vueCol = []
                    fieldRows.forEach(rowField => {
                        const itcol = rowField
                        const title = vm.$translate.getColTitle(itcol, vm.$store.state.lang)
                        vm.stkCol.push({title, key: itcol.key, align: itcol.align, width: itcol.width, thide: itcol.THIDE, fhide: itcol.FHIDE, edcss: itcol.EDCSS, disabled: itcol.DISABLED, dotnum: itcol.DOTNUM})
                        if (itcol.THIDE !== 'N') return
                        vm.vueCol.push({
                            field: itcol.key, key: itcol.key, title, align: itcol.align, width: Number(itcol.width) || 120,
                            sortable: false, ellipsis: {showTitle: true},
                            renderHeaderCell: ({column}) => <VeTableQueryHeader
                                title={column.title}
                                edcss={itcol.key === 'STFG' ? 'select' : itcol.EDCSS}
                                value={this.v_row[itcol.key]}
                                operator={this.v_row[`#OPER${itcol.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={itcol.key !== 'RN' && itcol.key !== 'SEL' && itcol.SORTABLE === 'N' && itcol.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === itcol.key ? this.headerSortOrder : ''}
                                options={itcol.key === 'STFG' ? [
                                    { value: 'Y', label: this.$LANG('1976', '已审') },
                                    { value: 'N', label: this.$LANG('2005', '未审') },
                                ] : (['select', 'checkbox'].includes(String(itcol.EDCSS || '').toLowerCase()) ? (this.comboArr[itcol.key] || []) : [])}
                                on-input={(value) => this.$set(this.v_row, itcol.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${itcol.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(column)}
                                on-query={this.stfgChange}
                            />,
                            renderBodyCell: ({row}) => {
                                const value = row[itcol.key]
                                if (itcol.key === 'IDNO') return <el-link underline={false} on-click={() => this.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;font-size:12px">{value}</div></el-link>
                                if (itcol.key === 'SEL') return <el-checkbox disabled={!!row.ARNO || row.STFG === 'N'} true-label="Y" false-label="N" v-model={row[itcol.key]} style="width:100%">&nbsp;</el-checkbox>
                                if (itcol.key === 'STFG') return value === 'Y' ? <el-tag size="mini" type="success" effect="dark">{this.$LANG('1976', '是')}</el-tag> : <el-tag size="mini" type="info" effect="dark">{this.$LANG('2005', '否')}</el-tag>
                                return <span>{value}</span>
                            },
                        })
                    })
                    vm.vueCol.unshift({field: 'index', key: 'rownum', title: vm.$LANG('0310', '序号'), width: 60, align: 'center', fixed: 'left', disableResizing: true, renderBodyCell: ({rowIndex}) => rowIndex + 1, renderHeaderCell: ({column}) => <div class="ord-sent-sequence-header"><div class="ord-sent-sequence-header__title">{column.title}</div><el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>})
                    vm.vueCol.push({
                        field: 'oper0', key: 'oper', title: vm.$LANG('0330', '状态操作'), width: 200, align: 'center', fixed: 'right', disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => <div>
                            <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link on-click={() => this.editRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0139', '查看')}</span></el-link>
                            {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.editBool} on-click={() => this.editRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('1639', '编辑')}</span></el-link><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0134', '审核')}</span></el-link><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:12px">{this.$LANG('0257', '作废')}</span></el-link></span> : null}
                            {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px"></i><el-link disabled={this.cfmBool} on-click={() => this.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:12px;margin-right:6px">{this.$LANG('0137', '弃审')}</span></el-link></span> : null}
                        </div>,
                    })
                    vm.applyFieldSettingRows()
                    return res
                })
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','470845','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                      title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        notnull:res.result[k].NOTNULL,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','470845','lstseq','4','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.ordCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
 
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ord-sent-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }

    .active { 
        color: #389;
        border-bottom:3px solid #cc0000;
        margin-right:2px;
    }
    .oneMenu{
        display:flex;
        flex-direction:column;
        line-height:25px;
        background:white;
        margin-top:3px;
        font-size:13px;
        font-weight: 600;
    }
    .oneMenu:hover{
        cursor: pointer;
        color:#cc0000;
        background:#f7f8f9;
        font-weight:700;
    }
    .item-width  {
        width: 32%;
        color:#409EFF;
        height:20px;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
